import { registerBlockType } from '@wordpress/blocks';
import Edit from './Edit';
import Save from './save';
import metadata from './block.json';
import './style.scss';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
			>
				<path
					d="M13.5 6C10.5 6 8 8.5 8 11.5c0 1.1.3 2.1.9 3l-3.4 3.4c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3l3.4-3.4c.9.6 1.9.9 3 .9 3 0 5.5-2.5 5.5-5.5S16.5 6 13.5 6zm0 9c-1.9 0-3.5-1.6-3.5-3.5S11.6 8 13.5 8 17 9.6 17 11.5 15.4 15 13.5 15z"
					fill="currentColor"
				/>
			</svg>
		),
	},
} );
